export default __webpack_public_path__ + "static/media/contract.abe75ae3.svg";